export const changeFirstCharToUpperCase = (inputString) => {
    let newString = "";
    let firstChar = inputString.substring(0,1);
    firstChar = firstChar.toUpperCase();
    const remainderString = inputString.substring(1, inputString.length);
    newString = firstChar + remainderString;
    return newString;
}
export default changeFirstCharToUpperCase;